import { render, staticRenderFns } from "./TypeIntegration.vue?vue&type=template&id=444d4078&scoped=true"
import script from "./TypeIntegration.vue?vue&type=script&lang=js"
export * from "./TypeIntegration.vue?vue&type=script&lang=js"
import style0 from "./TypeIntegration.vue?vue&type=style&index=0&id=444d4078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444d4078",
  null
  
)

export default component.exports